import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  RadioGroup,
  withConditional,
} from "@bleu.builders/ui";
import React from "react";

import { cn } from "#/lib/utils";

export const OnboardingRadioGroup = withConditional(({ form, field }) => (
  <FormField
    control={form.control}
    name={field.name}
    rules={field.required ? { required: true } : {}}
    render={({ field: rcfField }) => (
      <FormItem className="space-y-0 w-full">
        <FormControl>
          <RadioGroup
            value={rcfField.value}
            className={cn("py-2 flex w-full flex-wrap")}
          >
            {/* @ts-ignore */}
            {field.options.map((option) => (
              <FormItem
                key={option.value}
                className="flex items-center space-x-1 space-y-0"
              >
                <FormControl
                  onClick={() => {
                    rcfField.onChange(
                      rcfField.value === option.value ? null : option.value,
                    );
                  }}
                >
                  <div
                    className={cn(
                      "p-4 border shadow-md rounded-md hover:scale-[101%] hover:shadow-lg",
                      {
                        "border-primary border-2":
                          rcfField.value === option.value,
                      },
                    )}
                  >
                    <FormLabel className="font-normal" tooltip={option.tooltip}>
                      {option.label}
                    </FormLabel>
                  </div>
                </FormControl>
              </FormItem>
            ))}
          </RadioGroup>
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
));
